import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

/**
 * Admin-only routes answer 403 to everybody else. That is a denied action, not a
 * dead session (NetworkService tells them apart), so it is turned into `null`
 * here: the caller simply does not render the admin section.
 */
const nullOnForbidden = async (request) => {
    try {
        return await request();
    } catch (error) {
        if (error?.status === 403) return null;

        throw error;
    }
};

export default class CreditService {
    /** Balance of the current user — available to anybody logged in. */
    static async getMyWalletAsync() {
        return await NetworkService.getAsync(`${API_BASE_URL}/credits/me`);
    }

    /** Price list of the AI services (admin). `null` when the user is not one. */
    static async getPricingAsync() {
        return await nullOnForbidden(
            () => NetworkService.getAsync(`${API_BASE_URL}/credits/pricing`)
        );
    }

    static async updatePricingAsync(serviceKey, body) {
        return await nullOnForbidden(
            () => NetworkService.putAsync(`${API_BASE_URL}/credits/pricing/${serviceKey}`, body)
        );
    }

    static async topupAsync(body) {
        return await nullOnForbidden(
            () => NetworkService.postAsync(`${API_BASE_URL}/credits/topup`, body)
        );
    }
}
